// This file is automatically generated. Do not edit it directly.
import { createMiddleware } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'



export const requireSupabaseAuth = createMiddleware({ type: 'function' }).server(
  async ({ next }) => {
    try {
      const SUPABASE_URL = process.env.SUPABASE_URL || process.env.VITE_SUPABASE_URL;
      const SUPABASE_PUBLISHABLE_KEY = process.env.SUPABASE_PUBLISHABLE_KEY || process.env.VITE_SUPABASE_PUBLISHABLE_KEY;

      if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
        const message = `Missing Supabase environment variable(s). Ensure SUPABASE_URL and SUPABASE_PUBLISHABLE_KEY are set.`;
        console.error(`[Supabase Auth Middleware Error] ${message}`);
        throw new Response(message, { status: 500 });
      }
      
      const request = getRequest();

      if (!request?.headers) {
        throw new Response('Unauthorized: No request headers available', { status: 401 });
      }

      const authHeader = request.headers.get('authorization');

      if (!authHeader) {
        throw new Response('Unauthorized: No authorization header provided', { status: 401 });
      }

      if (!authHeader.startsWith('Bearer ')) {
        throw new Response('Unauthorized: Only Bearer tokens are supported', { status: 401 });
      }

      const token = authHeader.replace('Bearer ', '');
      if (!token) {
        throw new Response('Unauthorized: No token provided', { status: 401 });
      }

      const supabase = createClient<Database>(
        SUPABASE_URL!,
        SUPABASE_PUBLISHABLE_KEY!,
        {
          global: {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
          auth: {
            storage: undefined,
            persistSession: false,
            autoRefreshToken: false,
          },
        }
      );

      // Use getUser instead of getClaims for better compatibility and verification
      const { data, error } = await supabase.auth.getUser(token);
      if (error || !data?.user) {
        console.error('[Supabase Auth Middleware Error] Token verification failed:', error?.message);
        throw new Response('Unauthorized: Invalid token', { status: 401 });
      }

      return next({
        context: {
          supabase,
          userId: data.user.id,
          claims: (data.user as any).app_metadata || {}, // Fallback for claims
        },
      })
    } catch (e: any) {
      if (e instanceof Response) throw e;
      console.error('[Supabase Auth Middleware Critical Error]:', e);
      throw new Response(e.message || 'Internal Server Error', { status: 500 });
    }
  }
)

